class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 800);

        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    static setListeners() {
        //console.log('setListeners');
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        //console.log('toggleActiveFacets');
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        //console.log('renderPage');
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();


        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        const loadingSpinners = document.querySelectorAll(
            '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
        );
        loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer) {
            countContainer.classList.add('loading');
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl)
                ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
                : FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
        //console.log('renderSectionFromFetch');
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
                FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderProductCount(html);
                if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        //console.log('renderSectionFromCache');
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    }

    static renderProductGridContainer(html) {
        //console.log('renderProductGridContainer');

        const newDocument = new DOMParser().parseFromString(html, 'text/html');
        const productGridContainer = newDocument.getElementById('ProductGridContainer');




        document.getElementById('ProductGridContainer').innerHTML = productGridContainer.innerHTML;


        const gridElement = document.getElementById('product-grid');


        if (gridElement && gridElement.classList.contains('new-custom-class-for-new-sort-logic--collectionsize')) {


            const sortBySelect = document.getElementById('SortBy');
            const currentSortBy = sortBySelect ? sortBySelect.value : 'manual';




            if (sortBySelect.dataset.customSort === 'custom-sort-collection') {
                FacetFiltersForm.sortVariantsClientSide(gridElement, currentSortBy);
            }
        }


        document
            .getElementById('ProductGridContainer')
            .querySelectorAll('.scroll-trigger')
            .forEach((element) => {
                element.classList.add('scroll-trigger--cancel');
            });
    }

    static sortVariantsClientSide(gridElement, sortKey) {
        //console.log('sortVariantsClientSide');
        //console.warn('--- CUSTOM CLIENT-SIDE VARIANT SORTING TRIGGERED ---');
        //console.log('gridElement', gridElement);
        //console.log('sortKey', sortKey);

        const bestSellingRules = [
            { h: '17"', d: '4x8' },
            { h: '17"', d: '2x6' },
            { h: '32"', d: '4x8' },
            { h: '17"', d: '2x10' },
            { h: '17"', d: '4x4' },
            { h: '17"', d: '2x8' },
            { h: '17"', d: '4x6' },
            { h: '17"', d: '2x4' },
            { h: '32"', d: '2x6' },
            { h: '32"', d: '2x10' },
            { h: '32"', d: '2x8' },
            { h: '32"', d: '4x4' },
            { h: '32"', d: '4x6' },
            { h: '17"', d: '2x2' },
            { h: '32"', d: '2x4' },
            { h: '32"', d: '2x2' }
        ];


        const allItems = Array.from(gridElement.children);


        const sortableItems = [];
        const staticItemsMap = new Map();


        allItems.forEach((item, index) => {
            const hasPrice = item.querySelector('.price-and-option-wrapper .price__container .price-item');
            if (hasPrice) {
                sortableItems.push(item);
            } else {
                staticItemsMap.set(index, item);
            }
        });


        const getSortValue = (item) => {
            const titleText = item.querySelector('.custom-card-title-item--full-value').textContent
                .replace(/\s+/g, ' ')
                .trim();
                //console.log(titleText);
                


            if (sortKey.includes('best-selling') || sortKey === 'manual') {
                const rankIndex = bestSellingRules.findIndex(rule => {
                    // 1. Шукаємо розмір (напр. 4x8) з межами слова
                    const sizeRegex = new RegExp('\\b' + rule.d.replace('x', '[xX]') + '\\b');
                    const hasSize = sizeRegex.test(titleText);

                    // 2. Шукаємо висоту (17 або 32)
                    // Використовуємо тільки цифри для надійності, бо лапки (") можуть бути різними в HTML
                    const heightDigit = rule.h.replace(/\D/g, '');
                    const hasHeight = titleText.includes(heightDigit);

                    // ПОВИННІ бути присутні обидва параметри одночасно
                    return hasSize && hasHeight;
                });

                // Якщо rankIndex все ще -1, спробуємо логнути, щоб зрозуміти чому не знайшло
                if (rankIndex === -1) {
                    console.warn(`Could not find rank for: "${titleText}"`);
                } else {
                    //console.log(`Title: "${titleText}" | Matches Rule: ${bestSellingRules[rankIndex].h} ${bestSellingRules[rankIndex].d} | Rank: ${rankIndex}`);
                }

                return rankIndex !== -1 ? rankIndex : 999;
            }


            const priceText = item.querySelector('.price-and-option-wrapper .price__container .price-item').textContent.replace(/[^0-9,-]+/g, '').replace(',', '.');

            if (sortKey.includes('price')) {
                return parseFloat(priceText);
            }


            if (sortKey.includes('title')) {
                return titleText;
            }

            return 0;
        };

        // 3. Сортуємо ТІЛЬКИ продукти
        sortableItems.sort((a, b) => {
            const valA = getSortValue(a);
            const valB = getSortValue(b);

            // Спеціальна обробка для Best Selling (завжди від меншого до більшого, бо 0 - це топ)
            if (sortKey.includes('best-selling') || sortKey === 'manual') {
                return valA - valB;
            }

            if (typeof valA === 'string') {
                const comparison = valA.localeCompare(valB, 'uk', { sensitivity: 'base' });
                return sortKey.includes('desc') ? -comparison : comparison;
            } else {
                const comparison = valA - valB;
                return sortKey.includes('desc') ? -comparison : comparison;
            }
        });

        // 4. Перебудовуємо сітку (Merge)
        gridElement.innerHTML = '';

        let sortableIndex = 0; // Лічильник для відсортованих продуктів

        for (let i = 0; i < allItems.length; i++) {
            // Якщо на цьому індексі був банер - ставимо його назад
            if (staticItemsMap.has(i)) {
                gridElement.appendChild(staticItemsMap.get(i));
            } else {
                // Інакше вставляємо наступний відсортований продукт
                if (sortableItems[sortableIndex]) {
                    gridElement.appendChild(sortableItems[sortableIndex]);
                    sortableIndex++;
                }
            }
        }
    }

    static renderProductCount(html) {
        // console.log('renderProductCount');
        // console.log('html', html);
        const productGrid = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
        let count;
        if (productGrid && productGrid.classList.contains('new-custom-class-for-new-sort-logic--collectionsize')) {
            const amount = productGrid.querySelectorAll('li').length;
            //console.log('productGrid',productGrid);
            
            count = `${amount} products`;

        } else {
            count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;

        }


        //console.log('cooount', count);

        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        container.innerHTML = count;
        container.classList.remove('loading');
        if (containerDesktop) {
            containerDesktop.innerHTML = count;
            containerDesktop.classList.remove('loading');
        }
        const loadingSpinners = document.querySelectorAll(
            '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
        );
        loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    }

    static renderFilters(html, event) {
        //console.log('renderFilters');
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
            '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
        );
        const facetDetailsElementsFromDom = document.querySelectorAll(
            '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
        );

        // Remove facets that are no longer returned from the server
        Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
            if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
                currentElement.remove();
            }
        });

        const matchesId = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.id === jsFilter.id : false;
        };

        const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
        const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

        facetsToRender.forEach((elementToRender, index) => {
            const currentElement = document.getElementById(elementToRender.id);
            // Element already rendered in the DOM so just update the innerHTML
            if (currentElement) {
                document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
            } else {
                if (index > 0) {
                    const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
                    // Same facet type (eg horizontal/vertical or drawer/mobile)
                    if (elementToRender.className === previousElementClassName) {
                        document.getElementById(previousElementId).after(elementToRender);
                        return;
                    }
                }

                if (elementToRender.parentElement) {
                    document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
                }
            }
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) {
            const closestJSFilterID = event.target.closest('.js-filter').id;

            if (closestJSFilterID) {
                FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
                FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

                const newFacetDetailsElement = document.getElementById(closestJSFilterID);
                const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
                    ? `.mobile-facets__close-button`
                    : `.facets__summary`;
                const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

                const isTextInput = event.target.getAttribute('type') === 'text';

                if (newElementToActivate && !isTextInput) newElementToActivate.focus();
            }
        }
    }

    static renderActiveFacets(html) {
        //console.log('renderActiveFacets');
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];



        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);


            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });

        FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
        //console.log('renderAdditionalElements');
        const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        if (document.getElementById('FacetFiltersFormMobile')) {
            document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
        }
    }

    static renderCounts(source, target) {
        //console.log('renderCounts');
        const targetSummary = target.querySelector('.facets__summary');
        const sourceSummary = source.querySelector('.facets__summary');

        if (sourceSummary && targetSummary) {
            targetSummary.outerHTML = sourceSummary.outerHTML;
        }

        const targetHeaderElement = target.querySelector('.facets__header');
        const sourceHeaderElement = source.querySelector('.facets__header');

        if (sourceHeaderElement && targetHeaderElement) {
            targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
        }

        const targetWrapElement = target.querySelector('.facets-wrap');
        const sourceWrapElement = source.querySelector('.facets-wrap');

        if (sourceWrapElement && targetWrapElement) {
            const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
            if (isShowingMore) {
                sourceWrapElement
                    .querySelectorAll('.facets__item.hidden')
                    .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
            }

            targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
        }
    }

    static renderMobileCounts(source, target) {
        //console.log('renderMobileCounts');
        const targetFacetsList = target.querySelector('.mobile-facets__list');
        const sourceFacetsList = source.querySelector('.mobile-facets__list');

        if (sourceFacetsList && targetFacetsList) {
            targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        //console.log('updateURLHash');
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
        //console.log('getSections');
        return [
            {
                section: document.getElementById('product-grid').dataset.id,
            },
        ];
    }

    createSearchParams(form) {

        const formData = new FormData(form);


        return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');
        if (event.srcElement.className == 'mobile-facets__checkbox') {
            const searchParams = this.createSearchParams(event.target.closest('form'));
            this.onSubmitForm(searchParams, event);


        } else {
            const forms = [];
            const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile' || event.target.closest('form').id === 'FacetSortFormMobile';


            sortFilterForms.forEach((form) => {




                if (!isMobile) {
                    if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
                        forms.push(this.createSearchParams(form));

                    }
                } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortFormMobile') {
                    forms.push(this.createSearchParams(form));


                }
            });


            this.onSubmitForm(forms.join('&'), event);
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
            event.currentTarget.href.indexOf('?') == -1
                ? ''
                : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input').forEach((element) => {
            element.addEventListener('change', this.onRangeChange.bind(this));
            element.addEventListener('keydown', this.onKeyDown.bind(this));
        });
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    onKeyDown(event) {
        if (event.metaKey) return;

        const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
        if (!event.key.match(pattern)) event.preventDefault();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('data-min', 0);
        if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('data-min'));
        const max = Number(input.getAttribute('data-max'));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }

    closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
    }
}

customElements.define('facet-remove', FacetRemove);


class ColumnsOnMobile extends HTMLElement {
    constructor() {
        super();
        const buttons = this.querySelectorAll('button');
        const productGrid = document.querySelector('#product-grid');

        buttons.forEach(btn => {
            btn.addEventListener('click', (event) => {
                if (btn.id === 'two-columns') {
                    productGrid?.classList.remove('grid--1-col-tablet-down')
                    productGrid?.classList.add('grid--2-col-tablet-down')
                } else if (btn.id === 'one-column') {
                    productGrid?.classList.remove('grid--2-col-tablet-down')
                    productGrid?.classList.add('grid--1-col-tablet-down')
                }
            })
        });
    }
}

customElements.define('mobile-columns', ColumnsOnMobile);